import { AlertTriangle, Info } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * The "Why this matters" callout. Used to explain a decision the user is about to
 * make (gold) or a state that is blocking delivery (danger) — the main device for
 * making the pipeline legible to someone new to film production.
 */
export default function WhyBox({
  title,
  children,
  variant = 'info',
  className,
}: {
  title?: string;
  children: React.ReactNode;
  variant?: 'info' | 'danger';
  className?: string;
}) {
  const danger = variant === 'danger';
  const Icon = danger ? AlertTriangle : Info;
  return (
    <div
      className={cn(
        'flex gap-3 rounded-lg border border-l-[3px] p-3.5',
        danger
          ? 'border-destructive/35 border-l-destructive bg-destructive/10'
          : 'border-primary/35 border-l-primary bg-primary/10',
        className,
      )}
    >
      <Icon className={cn('mt-0.5 h-4 w-4 shrink-0', danger ? 'text-destructive' : 'text-primary')} />
      <p className="m-0 text-xs leading-relaxed text-muted-foreground">
        {title && <b className={cn('font-semibold', danger ? 'text-destructive' : 'text-primary')}>{title} </b>}
        {children}
      </p>
    </div>
  );
}
